// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.payment.CreateMoveInCostsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CreateMoveInCostsWebApiRequestDto, CreateMoveInCostsWebApiResponseDto } from '../..';

export const CreateMoveInCostsWebApiHandler_createMoveInCosts_Path = '/api/web/v1/payment/createMoveInCosts';

/**
 * Create move in costs
 */
export const CreateMoveInCostsWebApiHandler_createMoveInCosts = (
  postData: CreateMoveInCostsWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateMoveInCostsWebApiRequestDto, CreateMoveInCostsWebApiResponseDto>(
    {
      endpoint: CreateMoveInCostsWebApiHandler_createMoveInCosts_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
